import { render, staticRenderFns } from "./OnboardButtons.vue?vue&type=template&id=bb0ea1cc&scoped=true"
import script from "./OnboardButtons.vue?vue&type=script&lang=js"
export * from "./OnboardButtons.vue?vue&type=script&lang=js"
import style0 from "./OnboardButtons.vue?vue&type=style&index=0&id=bb0ea1cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0ea1cc",
  null
  
)

export default component.exports